// =============================================
// SCROLL REVEAL — IntersectionObserver reveal
// =============================================

(function () {
  var revealEls = document.querySelectorAll('.reveal');
  if (!revealEls.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  revealEls.forEach(function (el) {
    observer.observe(el);
  });

  // Immediately reveal page hero elements
  setTimeout(function () {
    document.querySelectorAll('.page-hero .reveal, .hero .reveal').forEach(function (el) {
      el.classList.add('in');
    });
  }, 60);
})();
